import { useState, useEffect, useLayoutEffect, useContext } from "react";
import { AppContext } from "../App";

export default function useJobCode() {
  const { location } = useContext(AppContext);
  const [popupVisible, setPopupVisible] = useState(false);
  const [jobCode, setJobCode] = useState("NP-UK-Bun-0004");

  useLayoutEffect(() => {
    const hcpPopup = document.querySelector(".hcp-popup-header");

    if (hcpPopup) {
      setPopupVisible(true);
    } else {
      setPopupVisible(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (popupVisible) {
      setJobCode("NP-UK-FENH-0025");
    } else {
      switch (location.pathname) {
        case "/hcp/":
        case "/hcp":
          setJobCode("PP-UK-FENH-0061");
          break;
        case "/par/":
          setJobCode("NP-UK-Bun-0014");
          break;
        case "/hcp/initiating-fenhuma":
          setJobCode("PP-UK-FENH-0063");
          break;
        case "/hcp/resources":
          setJobCode("PP-UK-FENH-0060");
          break;
        case "/hcp/contact-us":
          setJobCode("PP-UK-FENH-0062");
          break;
        case "/hcp/pi":
          setJobCode("PP-UK-FENH-0059");
          break;
        case "/patient/":
        case "/patient":
          setJobCode("NP-UK-FENH-0028");
          break;
        case "/patient/taking-fenhuma":
          setJobCode("NP-UK-FENH-0032");
          break;
        case "/patient/side-effects":
          setJobCode("NP-UK-FENH-0027");
          break;
        case "/patient/useful-resources":
          setJobCode("NP-UK-FENH-0030");
          break;
        case "/patient/why-have-i-been-prescribed-fenhuma":
          setJobCode("NP-UK-FENH-0029");
          break;
        default:
          setJobCode("");
          break;
      }
    }
  }, [popupVisible, location.pathname]);

  return jobCode;
}
